module.exports = __webpack_public_path__ + "img/vn.8bfe7863.jpg";